import 'core-js/stable'; // polyfills
import 'regenerator-runtime/runtime';
import '../../public/css/app.less';
import '../../public/css/appcenter.less';
import '../../public/css/components/AppCenter/LoggedOutHeaderFooter.less';
import React, { Component } from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { getRoutes } from '../../routes/routeHelpers';
import createStore from '../../client/store.js';
import { init as initL10n } from 'pp-react-l10n';
import { noop, throttle } from 'lodash';
import Marketplaces from '../../lib/singletons/marketplaces';
import Partners from '../../lib/singletons/partners';
import { toggleIsDesktop } from '../../client/actions/app';
import { toggleToolFavorite } from '../../client/actions/myapps';
import { clientLogger } from '../../client/lib/logger';
import loadLoggedOutHeaderFooter from '../../client/lib/loggedOutHeaderFooter';

const store = createStore(window.__INITIAL_STATE__);

initL10n({ content: window.dictionary, onContentMissing: noop });

// Get env specific config needed for initializing marketplaces and partners
const marketplaceConnectConfig = window.marketplaceConnect;

// Initialize marketplaces
Marketplaces.init(marketplaceConnectConfig);
Partners.init(marketplaceConnectConfig);

delete window.dictionary;
delete window.marketplaceConnect;

const checkMobile = () => {
  const desktopState = window.innerWidth >= 651;
  const state = store.getState();
  const { isDesktop } = state.app.deviceInfo;

  if (isDesktop !== desktopState) {
    store.dispatch(toggleIsDesktop(!isDesktop));
  }
};
checkMobile();
const throttleCheckMobile = throttle(checkMobile, 200);
window.addEventListener('resize', throttleCheckMobile);
document.addEventListener('quicklinks_fav_updated_new', e =>
  store.dispatch(toggleToolFavorite(e.detail))
);

if (process.env.NODE_ENV === 'development') {
  //webpack rewrites `process.env.NODE_ENV` using DefinePlugin definition during build process.
  // This is Removed from bundle if condition is false
  Promise.all([import('react-axe'), import('react-dom')]).then(arr => {
    arr[0].default(React, arr[1].default, 1000);
  });
}

class Root extends Component {
  componentDidCatch(err, _info) {
    clientLogger.warn('React Component Error', err);
  }

  render() {
    return (
      <Provider store={store}>
        <BrowserRouter basename="merchantapps">{getRoutes()}</BrowserRouter>
      </Provider>
    );
  }
}

loadLoggedOutHeaderFooter();

hydrate(<Root />, document.getElementById('merchanthub-wrapper'));

if (module.hot) {
  module.hot.accept(err => {
    // eslint-disable-next-line
    console.error('[HMR] error: ' + err);
  });
}
